const clearLocationHistory = () => {
  const locationHistory = window.locationHistory;

  const checkHistory = setInterval(() => {
    if (locationHistory !== window.locationHistory) {
      clearInterval(checkHistory);

      requestAnimationFrame(
        () =>
          (window.location.hash = Math.random()
            .toString(16)
            .substr(2, 8))
      );

      (window as any).locationHistory = null;
    }
  }, 1000 / 60);
};

export { clearLocationHistory };
